import type { AccessRole } from '@/constants/rbac';
import type { BulkInternalRole } from './types';

export const BULK_INTERNAL_ROLES: Array<{ value: BulkInternalRole; label: string }> = [
  { value: 'ADMIN_ROOT', label: 'Admin' },
  { value: 'ADMIN', label: 'Moderador' },
  { value: 'AGENT', label: 'Atendimento' },
  { value: 'CURATOR', label: 'Curador' },
  { value: 'CREATIVE', label: 'Curador' },
  { value: 'VIEWER', label: 'Visitante' },
];

export const BULK_INTERNAL_ROLE_VALUES = BULK_INTERNAL_ROLES.map((role) => role.value);

const MODERATOR_BULK_INTERNAL_ROLES: BulkInternalRole[] = [
  'AGENT',
  'CURATOR',
  'CREATIVE',
  'VIEWER',
];

export const getBulkInternalRolesForAccess = (role: AccessRole) => {
  if (role === 'MODERATOR') {
    return BULK_INTERNAL_ROLES.filter((item) =>
      MODERATOR_BULK_INTERNAL_ROLES.includes(item.value)
    );
  }
  return BULK_INTERNAL_ROLES;
};

export const INTERNAL_CSV_HEADERS = 'nome;email;role';

export const PARTNER_CSV_HEADERS = 'nome;email;whatsapp';

export const INTERNAL_SAMPLE_CSV = `${INTERNAL_CSV_HEADERS}
Maria Silva;maria@empresa.com;VIEWER
João Souza;joao@empresa.com;AGENT
`;

export const PARTNER_SAMPLE_CSV = `${PARTNER_CSV_HEADERS}
Ana Costa;ana@parceiro.com;+55 11 99999-0000
`;
